// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7f0afafa","453":"6382a727","455":"4a925997"}[chunkId] + ".chunk.js";
};